// extracted by mini-css-extract-plugin
export default {"formPrompt":"SurveyForm_formPrompt__cBzR1"};